import axiosClient from './axiosClient';

const userService = {
    currentVendor: async () => {
        const response = await axiosClient.get('/vendor');
        console.log('Vendor Data:', response.data.data);
        return response.data.data;
    },

    getAllUsers: async (params) => {
        const response = await axiosClient.get('/admin/users', { params });
        return response.data;
    },

    adminUpdateUser: async (userId, payload) => {
        const response = await axiosClient.put(`/admin/users/${userId}`, payload);
        return response.data;
    },

    banUser: async (userId, payload) => {
        const response = await axiosClient.put(`/admin/users/${userId}/ban`, payload);
        return response.data;
    },

    unbanUser: async (userId) => {
        const response = await axiosClient.put(`/admin/users/${userId}/unban`);
        return response.data;
    },

    // getVendorById: async (vendorId) => {
    //     const response = await axiosClient.get(`/admin/vendors/${vendorId}`);
    //     return response.data;
    // },

    getCustomerById: async (customerId) => {
        const response = await axiosClient.get(`/admin/customers/${customerId}`);
        return response.data;
    },

    getAllCustomers: async (params) => {
        const response = await axiosClient.get('/admin/customers/all', { params });
        return response.data;
    },

    getRiderById: async (riderId) => {
        const response = await axiosClient.get(`/admin/riders/${riderId}`);
        return response.data;
    },
    adminCreateRider: async (payload) => {
        const response = await axiosClient.post(`/admin/riders`, payload);
        return response.data;
    },
    adminUpdateRider: async (riderId, payload) => {
        const response = await axiosClient.put(`/admin/riders/${riderId}`, payload);
        return response.data;
    },
    adminGetAllRiders: async (params) => {
        const response = await axiosClient.get('/admin/riders/all', { params });
        console.log('hhh', response.data.data.user);
        return response.data;
    },

    adminGetUserKYC: async (userId) => {
        const response = await axiosClient.get(`/admin/kyc/user/${userId}`, { skipGlobalToast: true });
        return response.data;
    },

    me: async () => {
        const response = await axiosClient.get('/admin');
        return response.data.data;
    }
};

export default userService;
